<div v-if="options">
	<p>{{ $t('vm.components.popin.change-invoice-status-rfe.text') }}</p>
	<div class="choices u-mb-2">
		<radio-frame id="rfe-status-accept" name="rfe-status-group"
					 :value="options.statut" radio-value="accepted" default-class="p-like" @input="accept()">
			{{ $t('vm.components.popin.change-invoice-status-rfe.accept.label') }}
		</radio-frame>
		<radio-frame id="rfe-status-refuse" name="rfe-status-group"
					 :value="options.statut" radio-value="refused" default-class="p-like" @input="refuse()">
			{{ $t('vm.components.popin.change-invoice-status-rfe.refuse.label') }}
		</radio-frame>
	</div>
	<textarea-frame v-if="isRefused" id="rfe-refuse-reason" v-model="options.reason"
		:label="$t('vm.components.popin.change-invoice-status-rfe.reason.label')"
		:placeholder="$t('vm.components.popin.change-invoice-status-rfe.reason.placeholder')"/>
</div>
